import { render, staticRenderFns } from "./IllustrationPhoneBattery.svg?vue&type=template&id=a3a0bc52&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports